import React from 'react'
import ChartSwitch from '../chart-switch'
import Toolbar from '../toolbar'
import Table from './historical/table'
import Empty from './historical/empty'
import Layout from '../layout'
import SidebarHistorical from './historical/sidebar'
import CHART_MAP from './charts/chart-map'

class StrategiesHistorical extends React.PureComponent {
  render() {
    const { query, aggregate, strategies, series, region } = this.props

    const chart = {
      text: 'Performance History Aggregate'
    }

    return (
      <Layout query={query} region={region} section="strategies">
        <SidebarHistorical query={query} strategies={strategies} />

        <main role="main" className="performance-table">
          <Toolbar section="strategies" query={query} region={region} />

          <div className="performance-table__body">
            <div className="chart-container__chart performance-table__chart">
              <ChartSwitch
                chart={chart}
                chartMap={CHART_MAP}
                series={series}
                query={query}
              />
            </div>

            <div className="performance-table__tabular">
              {aggregate.length ? (
                <Table cells={aggregate} region={region} />
              ) : (
                <Empty />
              )}
            </div>
          </div>
        </main>
      </Layout>
    )
  }
}

export default StrategiesHistorical



// WEBPACK FOOTER //
// ./src/components/strategies/historical.js